import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const contactApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createContact: builder.mutation({
      query: (data) => ({
        url: apiRoutes.contact.create.path,
        method: apiRoutes.contact.create.reqType,
        body: data,
      }),
      invalidatesTags: ["Contacts"],
    }),
    deleteContact: builder.mutation({
      query: (id) => ({
        url: `${apiRoutes.contact.delete.path}/${id}`,
        method: apiRoutes.contact.delete.reqType,
      }),
      invalidatesTags: ["Contacts"],
    }),
    updateContact: builder.mutation({
      query: ({ id, data }) => ({
        url: `${apiRoutes.contact.edit.path}/${id}`,
        method: apiRoutes.contact.edit.reqType,
        body: data,
      }),
      invalidatesTags: ["Contacts"],
    }),
    getContacts: builder.mutation({
      query: () => ({
        url: `${apiRoutes.contact.get.path}`,
        method: apiRoutes.contact.get.reqType,
      }),
    }),
    getContactByEmail: builder.mutation({
      query: (data) => ({
        url: `${apiRoutes.contact.getByEmail.path}`,
        method: apiRoutes.contact.getByEmail.reqType,
        params: data,
      }),
    }),
  }),
});

export const {
  useCreateContactMutation,
  useDeleteContactMutation,
  useUpdateContactMutation,
  useGetContactsMutation,
  useGetContactByEmailMutation,
} = contactApiSlice;
